 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/EBB'
 import PORT from '@/components/port'
 import MM from '@/components/MM'
 import LOVE1 from '@/components/love1'
 import A1_TITLE from '@/components/01_Title'
 import A7815040759921 from '@/components/9781504075992-1'
 import A7815040759922 from '@/components/9781504075992-2'
 import A7815040759923 from '@/components/9781504075992-3'
 import A7815040759924 from '@/components/9781504075992-4'
 import A7815040759925 from '@/components/9781504075992-5'
 import A7815040759926 from '@/components/9781504075992-6'
 import A7815040759927 from '@/components/9781504075992-7'
 import A7815040759928 from '@/components/9781504075992-8'
 import A7815040759929 from '@/components/9781504075992-9'
 import A78150407599210 from '@/components/9781504075992-10'
 import A78150407599211 from '@/components/9781504075992-11'
 import A78150407599212 from '@/components/9781504075992-12'
 import A78150407599213 from '@/components/9781504075992-13'
 import A78150407599214 from '@/components/9781504075992-14'
 import A78150407599215 from '@/components/9781504075992-15'
 import LOVE2 from '@/components/love2'
 import AUTHOR from '@/components/Author'
 import COPYRIGHT from '@/components/copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/EBB",
 			"name" : "EBB",
 			"component" : EBB
 		},
 		{
 			"path" : "/port",
 			"name" : "port",
 			"component" : PORT
 		},
 		{
 			"path" : "/MM",
 			"name" : "MM",
 			"component" : MM
 		},
 		{
 			"path" : "/love1",
 			"name" : "love1",
 			"component" : LOVE1
 		},
 		{
 			"path" : "/01_Title",
 			"name" : "01_Title",
 			"component" : A1_TITLE
 		},
 		{
 			"path" : "/9781504075992-1",
 			"name" : "9781504075992-1",
 			"component" : A7815040759921
 		},
 		{
 			"path" : "/9781504075992-2",
 			"name" : "9781504075992-2",
 			"component" : A7815040759922
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js